/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type EntityActivityKind = "EDUCATIONAL" | "GOVERNMENT_AGENCY" | "NON_PROFIT" | "PARTNERSHIP" | "PRIVATELY_HELD" | "PUBLIC_COMPANY" | "SELF_EMPLOYED" | "SELF_OWNED" | "%future added value";
export type MediaAssetFileStatusKind = "AVAILABLE" | "CREATED" | "DELETED" | "ERROR" | "PROCESSING" | "%future added value";
export type MediaAssetStateKind = "AVAILABLE" | "CREATED" | "DELETED" | "PROCESSING" | "%future added value";
export type PreviewKind = "A_ROLE" | "BACKGROUND" | "BADGE_DARK" | "BADGE_LIGHT" | "B_ROLE" | "CAROUSEL" | "DETAIL_BACKGROUND" | "EXCERPT" | "HEADSHOT" | "HERO" | "HERO_LOGO" | "LOGO" | "PORTRAIT" | "SQUARE" | "%future added value";
export type SocialMediaPlatformKind = "ANGEL_LIST" | "FACEBOOK" | "INSTAGRAM" | "LINKED_IN" | "MEDIUM" | "OTHER" | "PINTEREST" | "REDDIT" | "SNAPCHAT" | "TUMBLR" | "TWITTER" | "WEIBO" | "WHATS_APP" | "YOU_TUBE" | "%future added value";
export type TopLevelMediaKind = "APPLICATION" | "AUDIO" | "DOCUMENT" | "IMAGE" | "TEXT" | "VIDEO" | "%future added value";
export type RemoveFromEntityInput = {
    readonly activities?: ReadonlyArray<EntityActivityKind> | null;
    readonly badges?: ReadonlyArray<string> | null;
    readonly clientMutationId: string;
    readonly force?: boolean | null;
    readonly id?: string | null;
    readonly investmentsBy?: ReadonlyArray<string> | null;
    readonly investmentsIn?: ReadonlyArray<string> | null;
    readonly locations?: ReadonlyArray<string> | null;
    readonly mediaAbout?: ReadonlyArray<string> | null;
    readonly people?: ReadonlyArray<string | null> | null;
    readonly northStar?: ReadonlyArray<string> | null;
    readonly portfolio?: ReadonlyArray<string> | null;
    readonly previews?: ReadonlyArray<PreviewKind> | null;
    readonly questionsResponses?: ReadonlyArray<string> | null;
    readonly revision?: string | null;
    readonly socialMediaCredentials?: ReadonlyArray<SocialMediaPlatformKind> | null;
    readonly socialMediaProfiles?: ReadonlyArray<SocialMediaPlatformKind> | null;
    readonly marketplace?: ReadonlyArray<string> | null;
    readonly tags?: ReadonlyArray<string> | null;
};
export type removeFromEntityMutationVariables = {
    readonly input: RemoveFromEntityInput;
};
export type removeFromEntityMutationResponse = {
    readonly removeFromEntity: {
        readonly clientMutationId: string;
        readonly hasErrors: boolean | null;
        readonly errors: ReadonlyArray<{
            readonly id: string;
            readonly location: string | null;
        } | null> | null;
        readonly entity: {
            readonly __typename: string;
            readonly id: string;
            readonly revision: string | null;
            readonly name: string | null;
            readonly description: string | null;
            readonly websiteUrl: string | null;
            readonly founded: unknown | null;
            readonly isEditable: boolean | null;
            readonly industry: string | null;
            readonly tagLine: string | null;
            readonly fundingRound: string | null;
            readonly isFundraising: boolean | null;
            readonly hasPortfolio: boolean | null;
            readonly portfolioMarketCap: string | null;
            readonly isFeedBaseEntity: boolean | null;
            readonly landingPageUrl: string | null;
            readonly activities: ReadonlyArray<{
                readonly kind: EntityActivityKind | null;
                readonly label: string | null;
            }> | null;
            readonly isClaimable: boolean | null;
            readonly pitchOriginalMedia: {
                readonly id: string;
            } | null;
            readonly investmentsBy: ReadonlyArray<{
                readonly amount: string | null;
                readonly link: string | null;
                readonly deckUrl: string | null;
                readonly investmentDate: unknown | null;
            }> | null;
            readonly opportunities: {
                readonly productAndServices: {
                    readonly description: string | null;
                    readonly link: string | null;
                    readonly email: string | null;
                } | null;
                readonly careers: {
                    readonly description: string | null;
                    readonly link: string | null;
                    readonly email: string | null;
                } | null;
                readonly collaboration: {
                    readonly description: string | null;
                    readonly link: string | null;
                    readonly email: string | null;
                } | null;
            } | null;
            readonly locations: ReadonlyArray<{
                readonly id: string | null;
                readonly label: string | null;
            }> | null;
            readonly headquarters: {
                readonly location: {
                    readonly label: string | null;
                } | null;
            } | null;
            readonly portfolioEntities: {
                readonly id: string;
            } | null;
            readonly portfolioPeople: {
                readonly id: string;
            } | null;
            readonly noOfPortfolioCompanies: {
                readonly maximum: number | null;
                readonly minimum: number | null;
                readonly isGreaterThan: boolean | null;
                readonly isLessThan: boolean | null;
            } | null;
            readonly noOfEmployees: {
                readonly maximum: number | null;
                readonly minimum: number | null;
                readonly isGreaterThan: boolean | null;
                readonly isLessThan: boolean | null;
            } | null;
            readonly previews: {
                readonly count: number | null;
                readonly edges: ReadonlyArray<{
                    readonly cursor: string | null;
                    readonly preview: {
                        readonly mediaAsset: {
                            readonly id: string;
                            readonly files: ReadonlyArray<{
                                readonly id: string;
                                readonly name: string | null;
                                readonly heightInPixels: number | null;
                                readonly widthInPixels: number | null;
                                readonly path: string | null;
                                readonly status: {
                                    readonly kind: MediaAssetFileStatusKind | null;
                                } | null;
                            }> | null;
                            readonly state: {
                                readonly kind: MediaAssetStateKind | null;
                            } | null;
                            readonly topLevelMediaType: {
                                readonly kind: TopLevelMediaKind | null;
                            } | null;
                        } | null;
                        readonly kind: PreviewKind | null;
                        readonly link: string | null;
                    } | null;
                }> | null;
            } | null;
            readonly socialMediaCredentials: ReadonlyArray<{
                readonly credential: string | null;
                readonly platform: {
                    readonly kind: SocialMediaPlatformKind | null;
                };
            }> | null;
            readonly socialMediaProfiles: ReadonlyArray<{
                readonly id: string;
                readonly link: string | null;
                readonly platform: {
                    readonly id: string;
                    readonly kind: SocialMediaPlatformKind | null;
                } | null;
            }> | null;
            readonly people: {
                readonly count: number | null;
                readonly pageInfo: {
                    readonly hasNextPage: boolean | null;
                } | null;
                readonly edges: ReadonlyArray<{
                    readonly role: string | null;
                    readonly person: {
                        readonly id: string;
                        readonly __typename: string;
                        readonly fullName: string | null;
                        readonly responsibility: string | null;
                        readonly description: string | null;
                        readonly landingPageUrl: string | null;
                        readonly previews: {
                            readonly count: number | null;
                            readonly edges: ReadonlyArray<{
                                readonly cursor: string | null;
                                readonly preview: {
                                    readonly mediaAsset: {
                                        readonly id: string;
                                        readonly files: ReadonlyArray<{
                                            readonly id: string;
                                            readonly name: string | null;
                                            readonly heightInPixels: number | null;
                                            readonly widthInPixels: number | null;
                                            readonly path: string | null;
                                            readonly status: {
                                                readonly kind: MediaAssetFileStatusKind | null;
                                            } | null;
                                        }> | null;
                                        readonly state: {
                                            readonly kind: MediaAssetStateKind | null;
                                        } | null;
                                        readonly topLevelMediaType: {
                                            readonly kind: TopLevelMediaKind | null;
                                        } | null;
                                    } | null;
                                    readonly kind: PreviewKind | null;
                                    readonly link: string | null;
                                } | null;
                            }> | null;
                        } | null;
                    };
                }> | null;
            } | null;
            readonly mediaAbout: {
                readonly count: number | null;
                readonly edges: ReadonlyArray<{
                    readonly cursor: string | null;
                    readonly story: ({
                        readonly __typename: string;
                        readonly id?: string;
                        readonly revision?: string | null;
                        readonly landingPageUrl?: string | null;
                        readonly sourceList?: string | null;
                        readonly durationInSeconds?: number | null;
                        readonly description?: string | null;
                        readonly externalId?: string | null;
                        readonly subTitle?: string | null;
                        readonly title?: string | null;
                        readonly label?: string | null;
                        readonly link?: string | null;
                        readonly previews?: {
                            readonly count: number | null;
                            readonly edges: ReadonlyArray<{
                                readonly cursor: string | null;
                                readonly preview: {
                                    readonly mediaAsset: {
                                        readonly id: string;
                                        readonly files: ReadonlyArray<{
                                            readonly id: string;
                                            readonly name: string | null;
                                            readonly heightInPixels: number | null;
                                            readonly widthInPixels: number | null;
                                            readonly path: string | null;
                                            readonly status: {
                                                readonly kind: MediaAssetFileStatusKind | null;
                                            } | null;
                                        }> | null;
                                        readonly state: {
                                            readonly kind: MediaAssetStateKind | null;
                                        } | null;
                                        readonly topLevelMediaType: {
                                            readonly kind: TopLevelMediaKind | null;
                                        } | null;
                                    } | null;
                                    readonly kind: PreviewKind | null;
                                    readonly link: string | null;
                                } | null;
                            }> | null;
                        } | null;
                        readonly content?: string | null;
                        readonly cost?: string | null;
                        readonly publishedDate?: unknown | null;
                        readonly timeRequiredInSeconds?: number | null;
                        readonly publisher?: string | null;
                        readonly timeToReadInSeconds?: number | null;
                    } & ({
                        readonly __typename: "OriginalContentStory";
                        readonly id: string;
                        readonly revision: string | null;
                        readonly landingPageUrl: string | null;
                        readonly sourceList: string | null;
                        readonly durationInSeconds: number | null;
                        readonly description: string | null;
                        readonly externalId: string | null;
                        readonly subTitle: string | null;
                        readonly title: string | null;
                        readonly label: string | null;
                        readonly link: string | null;
                        readonly previews: {
                            readonly count: number | null;
                            readonly edges: ReadonlyArray<{
                                readonly cursor: string | null;
                                readonly preview: {
                                    readonly mediaAsset: {
                                        readonly id: string;
                                        readonly files: ReadonlyArray<{
                                            readonly id: string;
                                            readonly name: string | null;
                                            readonly heightInPixels: number | null;
                                            readonly widthInPixels: number | null;
                                            readonly path: string | null;
                                            readonly status: {
                                                readonly kind: MediaAssetFileStatusKind | null;
                                            } | null;
                                        }> | null;
                                        readonly state: {
                                            readonly kind: MediaAssetStateKind | null;
                                        } | null;
                                        readonly topLevelMediaType: {
                                            readonly kind: TopLevelMediaKind | null;
                                        } | null;
                                    } | null;
                                    readonly kind: PreviewKind | null;
                                    readonly link: string | null;
                                } | null;
                            }> | null;
                        } | null;
                    } | {
                        readonly __typename: "RadivisionPost";
                        readonly content: string | null;
                    } | {
                        readonly __typename: "OnlineCourseStory";
                        readonly cost: string | null;
                        readonly publishedDate: unknown | null;
                        readonly timeRequiredInSeconds: number | null;
                        readonly publisher: string | null;
                    } | {
                        readonly __typename: "ArticleStory";
                        readonly timeToReadInSeconds: number | null;
                    } | {
                        /*This will never be '% other', but we need some
                        value in case none of the concrete values match.*/
                        readonly __typename: "%other";
                    })) | null;
                }> | null;
            } | null;
            readonly marketplace: {
                readonly count: number | null;
                readonly edges: ReadonlyArray<{
                    readonly cursor: string | null;
                    readonly story: ({
                        readonly __typename: string;
                        readonly id?: string;
                        readonly revision?: string | null;
                        readonly state?: string | null;
                        readonly expires?: unknown | null;
                        readonly landingPageUrl?: string | null;
                        readonly offerType?: string | null;
                        readonly description?: string | null;
                        readonly promoCode?: string | null;
                        readonly subTitle?: string | null;
                        readonly title?: string | null;
                        readonly label?: string | null;
                        readonly link?: string | null;
                        readonly previews?: {
                            readonly count: number | null;
                            readonly edges: ReadonlyArray<{
                                readonly cursor: string | null;
                                readonly preview: {
                                    readonly mediaAsset: {
                                        readonly id: string;
                                        readonly files: ReadonlyArray<{
                                            readonly id: string;
                                            readonly name: string | null;
                                            readonly heightInPixels: number | null;
                                            readonly widthInPixels: number | null;
                                            readonly path: string | null;
                                            readonly status: {
                                                readonly kind: MediaAssetFileStatusKind | null;
                                            } | null;
                                        }> | null;
                                        readonly state: {
                                            readonly kind: MediaAssetStateKind | null;
                                        } | null;
                                        readonly topLevelMediaType: {
                                            readonly kind: TopLevelMediaKind | null;
                                        } | null;
                                    } | null;
                                    readonly kind: PreviewKind | null;
                                    readonly link: string | null;
                                } | null;
                            }> | null;
                        } | null;
                    } & ({
                        readonly __typename: "MarketEntryStory";
                        readonly id: string;
                        readonly revision: string | null;
                        readonly state: string | null;
                        readonly expires: unknown | null;
                        readonly landingPageUrl: string | null;
                        readonly offerType: string | null;
                        readonly description: string | null;
                        readonly promoCode: string | null;
                        readonly subTitle: string | null;
                        readonly title: string | null;
                        readonly label: string | null;
                        readonly link: string | null;
                        readonly previews: {
                            readonly count: number | null;
                            readonly edges: ReadonlyArray<{
                                readonly cursor: string | null;
                                readonly preview: {
                                    readonly mediaAsset: {
                                        readonly id: string;
                                        readonly files: ReadonlyArray<{
                                            readonly id: string;
                                            readonly name: string | null;
                                            readonly heightInPixels: number | null;
                                            readonly widthInPixels: number | null;
                                            readonly path: string | null;
                                            readonly status: {
                                                readonly kind: MediaAssetFileStatusKind | null;
                                            } | null;
                                        }> | null;
                                        readonly state: {
                                            readonly kind: MediaAssetStateKind | null;
                                        } | null;
                                        readonly topLevelMediaType: {
                                            readonly kind: TopLevelMediaKind | null;
                                        } | null;
                                    } | null;
                                    readonly kind: PreviewKind | null;
                                    readonly link: string | null;
                                } | null;
                            }> | null;
                        } | null;
                    } | {
                        /*This will never be '% other', but we need some
                        value in case none of the concrete values match.*/
                        readonly __typename: "%other";
                    })) | null;
                }> | null;
            } | null;
        } | null;
    } | null;
};
export type removeFromEntityMutation = {
    readonly response: removeFromEntityMutationResponse;
    readonly variables: removeFromEntityMutationVariables;
};



/*
mutation removeFromEntityMutation(
  $input: RemoveFromEntityInput!
) {
  removeFromEntity(input: $input) {
    clientMutationId
    hasErrors
    errors {
      id
      location
    }
    entity {
      __typename
      id
      revision
      name
      description
      websiteUrl
      founded
      isEditable
      industry
      tagLine
      fundingRound
      isFundraising
      hasPortfolio
      portfolioMarketCap
      isFeedBaseEntity
      landingPageUrl
      activities {
        kind
        label
        id
      }
      isClaimable
      pitchOriginalMedia {
        id
      }
      investmentsBy {
        amount
        link
        deckUrl
        investmentDate
        id
      }
      opportunities {
        productAndServices {
          description
          link
          email
        }
        careers {
          description
          link
          email
        }
        collaboration {
          description
          link
          email
        }
        id
      }
      locations {
        id
        label
      }
      headquarters {
        location {
          label
          id
        }
        id
      }
      portfolioEntities {
        id
      }
      portfolioPeople {
        id
      }
      noOfPortfolioCompanies {
        maximum
        minimum
        isGreaterThan
        isLessThan
      }
      noOfEmployees {
        maximum
        minimum
        isGreaterThan
        isLessThan
      }
      previews {
        count
        edges {
          cursor
          preview {
            mediaAsset {
              id
              files {
                id
                name
                heightInPixels
                widthInPixels
                path
                status {
                  kind
                  id
                }
              }
              state {
                kind
                id
              }
              topLevelMediaType {
                kind
                id
              }
            }
            kind
            link
          }
        }
      }
      socialMediaCredentials {
        credential
        platform {
          kind
          id
        }
        id
      }
      socialMediaProfiles {
        id
        link
        platform {
          id
          kind
        }
      }
      people(first: 24) {
        count
        pageInfo {
          hasNextPage
        }
        edges {
          role
          person {
            id
            __typename
            fullName
            responsibility
            description
            landingPageUrl
            previews {
              count
              edges {
                cursor
                preview {
                  mediaAsset {
                    id
                    files {
                      id
                      name
                      heightInPixels
                      widthInPixels
                      path
                      status {
                        kind
                        id
                      }
                    }
                    state {
                      kind
                      id
                    }
                    topLevelMediaType {
                      kind
                      id
                    }
                  }
                  kind
                  link
                }
              }
            }
          }
        }
      }
      mediaAbout {
        count
        edges {
          cursor
          story {
            __typename
            ... on OriginalContentStory {
              __typename
              id
              revision
              landingPageUrl
              sourceList
              durationInSeconds
              description
              externalId
              subTitle
              title
              label
              link
              previews {
                count
                edges {
                  cursor
                  preview {
                    mediaAsset {
                      id
                      files {
                        id
                        name
                        heightInPixels
                        widthInPixels
                        path
                        status {
                          kind
                          id
                        }
                      }
                      state {
                        kind
                        id
                      }
                      topLevelMediaType {
                        kind
                        id
                      }
                    }
                    kind
                    link
                  }
                }
              }
            }
            ... on RadivisionPost {
              __typename
              id
              link
              previews {
                count
                edges {
                  cursor
                  preview {
                    mediaAsset {
                      id
                      files {
                        id
                        name
                        heightInPixels
                        widthInPixels
                        path
                        status {
                          kind
                          id
                        }
                      }
                      state {
                        kind
                        id
                      }
                      topLevelMediaType {
                        kind
                        id
                      }
                    }
                    kind
                    link
                  }
                }
              }
              subTitle
              title
              description
              content
              landingPageUrl
              revision
            }
            ... on OnlineCourseStory {
              __typename
              description
              id
              link
              cost
              previews {
                count
                edges {
                  cursor
                  preview {
                    mediaAsset {
                      id
                      files {
                        id
                        name
                        heightInPixels
                        widthInPixels
                        path
                        status {
                          kind
                          id
                        }
                      }
                      state {
                        kind
                        id
                      }
                      topLevelMediaType {
                        kind
                        id
                      }
                    }
                    kind
                    link
                  }
                }
              }
              subTitle
              title
              publishedDate
              timeRequiredInSeconds
              publisher
              revision
            }
            ... on ArticleStory {
              __typename
              description
              id
              link
              subTitle
              title
              publisher
              publishedDate
              timeToReadInSeconds
              revision
              previews {
                count
                edges {
                  cursor
                  preview {
                    mediaAsset {
                      id
                      files {
                        id
                        name
                        heightInPixels
                        widthInPixels
                        path
                        status {
                          kind
                          id
                        }
                      }
                      state {
                        kind
                        id
                      }
                      topLevelMediaType {
                        kind
                        id
                      }
                    }
                    kind
                    link
                  }
                }
              }
            }
            ... on BookStory {
              __typename
              description
              id
              link
              previews {
                count
                edges {
                  cursor
                  preview {
                    mediaAsset {
                      id
                      files {
                        id
                        name
                        heightInPixels
                        widthInPixels
                        path
                        status {
                          kind
                          id
                        }
                      }
                      state {
                        kind
                        id
                      }
                      topLevelMediaType {
                        kind
                        id
                      }
                    }
                    kind
                    link
                  }
                }
              }
              subTitle
              title
            }
            ... on NewsletterStory {
              __typename
              description
              link
              id
              previews {
                count
                edges {
                  cursor
                  preview {
                    mediaAsset {
                      id
                      files {
                        id
                        name
                        heightInPixels
                        widthInPixels
                        path
                        status {
                          kind
                          id
                        }
                      }
                      state {
                        kind
                        id
                      }
                      topLevelMediaType {
                        kind
                        id
                      }
                    }
                    kind
                    link
                  }
                }
              }
              subTitle
              title
              publisher
              publishedDate
              timeToReadInSeconds
            }
            ... on PodcastStory {
              __typename
              description
              durationInSeconds
              id
              title
              subTitle
              link
              publisher
              landingPageUrl
              previews {
                count
                edges {
                  cursor
                  preview {
                    mediaAsset {
                      id
                      files {
                        id
                        name
                        heightInPixels
                        widthInPixels
                        path
                        status {
                          kind
                          id
                        }
                      }
                      state {
                        kind
                        id
                      }
                      topLevelMediaType {
                        kind
                        id
                      }
                    }
                    kind
                    link
                  }
                }
              }
              revision
            }
            ... on Node {
              id
            }
          }
        }
      }
      marketplace {
        count
        edges {
          cursor
          story {
            __typename
            ... on MarketEntryStory {
              __typename
              id
              revision
              state
              expires
              landingPageUrl
              offerType
              description
              promoCode
              subTitle
              title
              label
              link
              previews {
                count
                edges {
                  cursor
                  preview {
                    mediaAsset {
                      id
                      files {
                        id
                        name
                        heightInPixels
                        widthInPixels
                        path
                        status {
                          kind
                          id
                        }
                      }
                      state {
                        kind
                        id
                      }
                      topLevelMediaType {
                        kind
                        id
                      }
                    }
                    kind
                    link
                  }
                }
              }
            }
            ... on Node {
              id
            }
          }
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "RemoveFromEntityInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "clientMutationId",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasErrors",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "errors",
  "storageKey": null,
  "args": null,
  "concreteType": "Error",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "location",
      "args": null,
      "storageKey": null
    }
  ]
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "revision",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "websiteUrl",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "founded",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isEditable",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "industry",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "tagLine",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fundingRound",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isFundraising",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasPortfolio",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "portfolioMarketCap",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isFeedBaseEntity",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "landingPageUrl",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "kind",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "label",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isClaimable",
  "args": null,
  "storageKey": null
},
v24 = [
  (v4/*: any*/)
],
v25 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pitchOriginalMedia",
  "storageKey": null,
  "args": null,
  "concreteType": "PitchVideoStory",
  "plural": false,
  "selections": (v24/*: any*/)
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "link",
  "args": null,
  "storageKey": null
},
v28 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "deckUrl",
  "args": null,
  "storageKey": null
},
v29 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "investmentDate",
  "args": null,
  "storageKey": null
},
v30 = [
  (v9/*: any*/),
  (v27/*: any*/),
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "email",
    "args": null,
    "storageKey": null
  }
],
v31 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "productAndServices",
  "storageKey": null,
  "args": null,
  "concreteType": "OpportunitiesItem",
  "plural": false,
  "selections": (v30/*: any*/)
},
v32 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "careers",
  "storageKey": null,
  "args": null,
  "concreteType": "OpportunitiesItem",
  "plural": false,
  "selections": (v30/*: any*/)
},
v33 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "collaboration",
  "storageKey": null,
  "args": null,
  "concreteType": "OpportunitiesItem",
  "plural": false,
  "selections": (v30/*: any*/)
},
v34 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "locations",
  "storageKey": null,
  "args": null,
  "concreteType": "EntityLocation",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v22/*: any*/)
  ]
},
v35 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "portfolioEntities",
  "storageKey": null,
  "args": null,
  "concreteType": "ListCollection",
  "plural": false,
  "selections": (v24/*: any*/)
},
v36 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "portfolioPeople",
  "storageKey": null,
  "args": null,
  "concreteType": "ListCollection",
  "plural": false,
  "selections": (v24/*: any*/)
},
v37 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "maximum",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "minimum",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "isGreaterThan",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "isLessThan",
    "args": null,
    "storageKey": null
  }
],
v38 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "noOfPortfolioCompanies",
  "storageKey": null,
  "args": null,
  "concreteType": "Range",
  "plural": false,
  "selections": (v37/*: any*/)
},
v39 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "noOfEmployees",
  "storageKey": null,
  "args": null,
  "concreteType": "Range",
  "plural": false,
  "selections": (v37/*: any*/)
},
v40 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v41 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v42 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "heightInPixels",
  "args": null,
  "storageKey": null
},
v43 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "widthInPixels",
  "args": null,
  "storageKey": null
},
v44 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "path",
  "args": null,
  "storageKey": null
},
v45 = [
  (v21/*: any*/)
],
v46 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": [
    (v40/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PreviewEdge",
      "plural": true,
      "selections": [
        (v41/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "preview",
          "storageKey": null,
          "args": null,
          "concreteType": "Preview",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "mediaAsset",
              "storageKey": null,
              "args": null,
              "concreteType": "MediaAsset",
              "plural": false,
              "selections": [
                (v4/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "files",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MediaAssetFile",
                  "plural": true,
                  "selections": [
                    (v4/*: any*/),
                    (v8/*: any*/),
                    (v42/*: any*/),
                    (v43/*: any*/),
                    (v44/*: any*/),
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "status",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "MediaAssetFileStatus",
                      "plural": false,
                      "selections": (v45/*: any*/)
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "state",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MediaAssetState",
                  "plural": false,
                  "selections": (v45/*: any*/)
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "topLevelMediaType",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "TopLevelMediaType",
                  "plural": false,
                  "selections": (v45/*: any*/)
                }
              ]
            },
            (v21/*: any*/),
            (v27/*: any*/)
          ]
        }
      ]
    }
  ]
},
v47 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "credential",
  "args": null,
  "storageKey": null
},
v48 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "socialMediaProfiles",
  "storageKey": null,
  "args": null,
  "concreteType": "SocialMediaProfile",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v27/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "platform",
      "storageKey": null,
      "args": null,
      "concreteType": "SocialMediaPlatform",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v21/*: any*/)
      ]
    }
  ]
},
v49 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 24
  }
],
v50 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
},
v51 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "role",
  "args": null,
  "storageKey": null
},
v52 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fullName",
  "args": null,
  "storageKey": null
},
v53 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "responsibility",
  "args": null,
  "storageKey": null
},
v54 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "sourceList",
  "args": null,
  "storageKey": null
},
v55 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "durationInSeconds",
  "args": null,
  "storageKey": null
},
v56 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "externalId",
  "args": null,
  "storageKey": null
},
v57 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "subTitle",
  "args": null,
  "storageKey": null
},
v58 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v59 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "content",
  "args": null,
  "storageKey": null
},
v60 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cost",
  "args": null,
  "storageKey": null
},
v61 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "publishedDate",
  "args": null,
  "storageKey": null
},
v62 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "timeRequiredInSeconds",
  "args": null,
  "storageKey": null
},
v63 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "publisher",
  "args": null,
  "storageKey": null
},
v64 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "timeToReadInSeconds",
  "args": null,
  "storageKey": null
},
v65 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "state",
  "args": null,
  "storageKey": null
},
v66 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "expires",
  "args": null,
  "storageKey": null
},
v67 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "offerType",
  "args": null,
  "storageKey": null
},
v68 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "promoCode",
  "args": null,
  "storageKey": null
},
v69 = [
  (v21/*: any*/),
  (v4/*: any*/)
],
v70 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": [
    (v40/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PreviewEdge",
      "plural": true,
      "selections": [
        (v41/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "preview",
          "storageKey": null,
          "args": null,
          "concreteType": "Preview",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "mediaAsset",
              "storageKey": null,
              "args": null,
              "concreteType": "MediaAsset",
              "plural": false,
              "selections": [
                (v4/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "files",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MediaAssetFile",
                  "plural": true,
                  "selections": [
                    (v4/*: any*/),
                    (v8/*: any*/),
                    (v42/*: any*/),
                    (v43/*: any*/),
                    (v44/*: any*/),
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "status",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "MediaAssetFileStatus",
                      "plural": false,
                      "selections": (v69/*: any*/)
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "state",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MediaAssetState",
                  "plural": false,
                  "selections": (v69/*: any*/)
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "topLevelMediaType",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "TopLevelMediaType",
                  "plural": false,
                  "selections": (v69/*: any*/)
                }
              ]
            },
            (v21/*: any*/),
            (v27/*: any*/)
          ]
        }
      ]
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "removeFromEntityMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "removeFromEntity",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateDeleteUpdateEntityPayload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v5/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "entity",
            "storageKey": null,
            "args": null,
            "concreteType": "Entity",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v4/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "activities",
                "storageKey": null,
                "args": null,
                "concreteType": "EntityActivity",
                "plural": true,
                "selections": [
                  (v21/*: any*/),
                  (v22/*: any*/)
                ]
              },
              (v23/*: any*/),
              (v25/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "investmentsBy",
                "storageKey": null,
                "args": null,
                "concreteType": "Investment",
                "plural": true,
                "selections": [
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "opportunities",
                "storageKey": null,
                "args": null,
                "concreteType": "Opportunities",
                "plural": false,
                "selections": [
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/)
                ]
              },
              (v34/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "headquarters",
                "storageKey": null,
                "args": null,
                "concreteType": "Contact",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "location",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "GeographicalLocation",
                    "plural": false,
                    "selections": [
                      (v22/*: any*/)
                    ]
                  }
                ]
              },
              (v35/*: any*/),
              (v36/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v46/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "socialMediaCredentials",
                "storageKey": null,
                "args": null,
                "concreteType": "SocialMediaCredential",
                "plural": true,
                "selections": [
                  (v47/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "platform",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SocialMediaPlatform",
                    "plural": false,
                    "selections": (v45/*: any*/)
                  }
                ]
              },
              (v48/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "people",
                "storageKey": "people(first:24)",
                "args": (v49/*: any*/),
                "concreteType": "EntityOwnersConnection",
                "plural": false,
                "selections": [
                  (v40/*: any*/),
                  (v50/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EntityOwner",
                    "plural": true,
                    "selections": [
                      (v51/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "person",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Person",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v6/*: any*/),
                          (v52/*: any*/),
                          (v53/*: any*/),
                          (v9/*: any*/),
                          (v20/*: any*/),
                          (v46/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "mediaAbout",
                "storageKey": null,
                "args": null,
                "concreteType": "StoriesConnection",
                "plural": false,
                "selections": [
                  (v40/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "StoryEdge",
                    "plural": true,
                    "selections": [
                      (v41/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "story",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "type": "OriginalContentStory",
                            "selections": [
                              (v4/*: any*/),
                              (v7/*: any*/),
                              (v20/*: any*/),
                              (v54/*: any*/),
                              (v55/*: any*/),
                              (v9/*: any*/),
                              (v56/*: any*/),
                              (v57/*: any*/),
                              (v58/*: any*/),
                              (v22/*: any*/),
                              (v27/*: any*/),
                              (v46/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "RadivisionPost",
                            "selections": [
                              (v4/*: any*/),
                              (v27/*: any*/),
                              (v46/*: any*/),
                              (v57/*: any*/),
                              (v58/*: any*/),
                              (v9/*: any*/),
                              (v59/*: any*/),
                              (v20/*: any*/),
                              (v7/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "OnlineCourseStory",
                            "selections": [
                              (v9/*: any*/),
                              (v4/*: any*/),
                              (v27/*: any*/),
                              (v60/*: any*/),
                              (v46/*: any*/),
                              (v57/*: any*/),
                              (v58/*: any*/),
                              (v61/*: any*/),
                              (v62/*: any*/),
                              (v63/*: any*/),
                              (v7/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "ArticleStory",
                            "selections": [
                              (v9/*: any*/),
                              (v4/*: any*/),
                              (v27/*: any*/),
                              (v57/*: any*/),
                              (v58/*: any*/),
                              (v63/*: any*/),
                              (v61/*: any*/),
                              (v64/*: any*/),
                              (v7/*: any*/),
                              (v46/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "BookStory",
                            "selections": [
                              (v9/*: any*/),
                              (v4/*: any*/),
                              (v27/*: any*/),
                              (v46/*: any*/),
                              (v57/*: any*/),
                              (v58/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "NewsletterStory",
                            "selections": [
                              (v9/*: any*/),
                              (v27/*: any*/),
                              (v4/*: any*/),
                              (v46/*: any*/),
                              (v57/*: any*/),
                              (v58/*: any*/),
                              (v63/*: any*/),
                              (v61/*: any*/),
                              (v64/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "PodcastStory",
                            "selections": [
                              (v9/*: any*/),
                              (v55/*: any*/),
                              (v4/*: any*/),
                              (v58/*: any*/),
                              (v57/*: any*/),
                              (v27/*: any*/),
                              (v63/*: any*/),
                              (v20/*: any*/),
                              (v46/*: any*/),
                              (v7/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "marketplace",
                "storageKey": null,
                "args": null,
                "concreteType": "StoriesConnection",
                "plural": false,
                "selections": [
                  (v40/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "StoryEdge",
                    "plural": true,
                    "selections": [
                      (v41/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "story",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "type": "MarketEntryStory",
                            "selections": [
                              (v4/*: any*/),
                              (v7/*: any*/),
                              (v65/*: any*/),
                              (v66/*: any*/),
                              (v20/*: any*/),
                              (v67/*: any*/),
                              (v9/*: any*/),
                              (v68/*: any*/),
                              (v57/*: any*/),
                              (v58/*: any*/),
                              (v22/*: any*/),
                              (v27/*: any*/),
                              (v46/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "removeFromEntityMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "removeFromEntity",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateDeleteUpdateEntityPayload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v5/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "entity",
            "storageKey": null,
            "args": null,
            "concreteType": "Entity",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v4/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "activities",
                "storageKey": null,
                "args": null,
                "concreteType": "EntityActivity",
                "plural": true,
                "selections": [
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v4/*: any*/)
                ]
              },
              (v23/*: any*/),
              (v25/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "investmentsBy",
                "storageKey": null,
                "args": null,
                "concreteType": "Investment",
                "plural": true,
                "selections": [
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v4/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "opportunities",
                "storageKey": null,
                "args": null,
                "concreteType": "Opportunities",
                "plural": false,
                "selections": [
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/),
                  (v4/*: any*/)
                ]
              },
              (v34/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "headquarters",
                "storageKey": null,
                "args": null,
                "concreteType": "Contact",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "location",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "GeographicalLocation",
                    "plural": false,
                    "selections": [
                      (v22/*: any*/),
                      (v4/*: any*/)
                    ]
                  },
                  (v4/*: any*/)
                ]
              },
              (v35/*: any*/),
              (v36/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v70/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "socialMediaCredentials",
                "storageKey": null,
                "args": null,
                "concreteType": "SocialMediaCredential",
                "plural": true,
                "selections": [
                  (v47/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "platform",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SocialMediaPlatform",
                    "plural": false,
                    "selections": (v69/*: any*/)
                  },
                  (v4/*: any*/)
                ]
              },
              (v48/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "people",
                "storageKey": "people(first:24)",
                "args": (v49/*: any*/),
                "concreteType": "EntityOwnersConnection",
                "plural": false,
                "selections": [
                  (v40/*: any*/),
                  (v50/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EntityOwner",
                    "plural": true,
                    "selections": [
                      (v51/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "person",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Person",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v6/*: any*/),
                          (v52/*: any*/),
                          (v53/*: any*/),
                          (v9/*: any*/),
                          (v20/*: any*/),
                          (v70/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "mediaAbout",
                "storageKey": null,
                "args": null,
                "concreteType": "StoriesConnection",
                "plural": false,
                "selections": [
                  (v40/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "StoryEdge",
                    "plural": true,
                    "selections": [
                      (v41/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "story",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v4/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "type": "OriginalContentStory",
                            "selections": [
                              (v7/*: any*/),
                              (v20/*: any*/),
                              (v54/*: any*/),
                              (v55/*: any*/),
                              (v9/*: any*/),
                              (v56/*: any*/),
                              (v57/*: any*/),
                              (v58/*: any*/),
                              (v22/*: any*/),
                              (v27/*: any*/),
                              (v70/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "RadivisionPost",
                            "selections": [
                              (v27/*: any*/),
                              (v70/*: any*/),
                              (v57/*: any*/),
                              (v58/*: any*/),
                              (v9/*: any*/),
                              (v59/*: any*/),
                              (v20/*: any*/),
                              (v7/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "OnlineCourseStory",
                            "selections": [
                              (v9/*: any*/),
                              (v27/*: any*/),
                              (v60/*: any*/),
                              (v70/*: any*/),
                              (v57/*: any*/),
                              (v58/*: any*/),
                              (v61/*: any*/),
                              (v62/*: any*/),
                              (v63/*: any*/),
                              (v7/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "ArticleStory",
                            "selections": [
                              (v9/*: any*/),
                              (v27/*: any*/),
                              (v57/*: any*/),
                              (v58/*: any*/),
                              (v63/*: any*/),
                              (v61/*: any*/),
                              (v64/*: any*/),
                              (v7/*: any*/),
                              (v70/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "BookStory",
                            "selections": [
                              (v9/*: any*/),
                              (v27/*: any*/),
                              (v70/*: any*/),
                              (v57/*: any*/),
                              (v58/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "NewsletterStory",
                            "selections": [
                              (v9/*: any*/),
                              (v27/*: any*/),
                              (v70/*: any*/),
                              (v57/*: any*/),
                              (v58/*: any*/),
                              (v63/*: any*/),
                              (v61/*: any*/),
                              (v64/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "PodcastStory",
                            "selections": [
                              (v9/*: any*/),
                              (v55/*: any*/),
                              (v58/*: any*/),
                              (v57/*: any*/),
                              (v27/*: any*/),
                              (v63/*: any*/),
                              (v20/*: any*/),
                              (v70/*: any*/),
                              (v7/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "marketplace",
                "storageKey": null,
                "args": null,
                "concreteType": "StoriesConnection",
                "plural": false,
                "selections": [
                  (v40/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "StoryEdge",
                    "plural": true,
                    "selections": [
                      (v41/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "story",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v4/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "type": "MarketEntryStory",
                            "selections": [
                              (v7/*: any*/),
                              (v65/*: any*/),
                              (v66/*: any*/),
                              (v20/*: any*/),
                              (v67/*: any*/),
                              (v9/*: any*/),
                              (v68/*: any*/),
                              (v57/*: any*/),
                              (v58/*: any*/),
                              (v22/*: any*/),
                              (v27/*: any*/),
                              (v70/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "removeFromEntityMutation",
    "id": null,
    "text": "mutation removeFromEntityMutation(\n  $input: RemoveFromEntityInput!\n) {\n  removeFromEntity(input: $input) {\n    clientMutationId\n    hasErrors\n    errors {\n      id\n      location\n    }\n    entity {\n      __typename\n      id\n      revision\n      name\n      description\n      websiteUrl\n      founded\n      isEditable\n      industry\n      tagLine\n      fundingRound\n      isFundraising\n      hasPortfolio\n      portfolioMarketCap\n      isFeedBaseEntity\n      landingPageUrl\n      activities {\n        kind\n        label\n        id\n      }\n      isClaimable\n      pitchOriginalMedia {\n        id\n      }\n      investmentsBy {\n        amount\n        link\n        deckUrl\n        investmentDate\n        id\n      }\n      opportunities {\n        productAndServices {\n          description\n          link\n          email\n        }\n        careers {\n          description\n          link\n          email\n        }\n        collaboration {\n          description\n          link\n          email\n        }\n        id\n      }\n      locations {\n        id\n        label\n      }\n      headquarters {\n        location {\n          label\n          id\n        }\n        id\n      }\n      portfolioEntities {\n        id\n      }\n      portfolioPeople {\n        id\n      }\n      noOfPortfolioCompanies {\n        maximum\n        minimum\n        isGreaterThan\n        isLessThan\n      }\n      noOfEmployees {\n        maximum\n        minimum\n        isGreaterThan\n        isLessThan\n      }\n      previews {\n        count\n        edges {\n          cursor\n          preview {\n            mediaAsset {\n              id\n              files {\n                id\n                name\n                heightInPixels\n                widthInPixels\n                path\n                status {\n                  kind\n                  id\n                }\n              }\n              state {\n                kind\n                id\n              }\n              topLevelMediaType {\n                kind\n                id\n              }\n            }\n            kind\n            link\n          }\n        }\n      }\n      socialMediaCredentials {\n        credential\n        platform {\n          kind\n          id\n        }\n        id\n      }\n      socialMediaProfiles {\n        id\n        link\n        platform {\n          id\n          kind\n        }\n      }\n      people(first: 24) {\n        count\n        pageInfo {\n          hasNextPage\n        }\n        edges {\n          role\n          person {\n            id\n            __typename\n            fullName\n            responsibility\n            description\n            landingPageUrl\n            previews {\n              count\n              edges {\n                cursor\n                preview {\n                  mediaAsset {\n                    id\n                    files {\n                      id\n                      name\n                      heightInPixels\n                      widthInPixels\n                      path\n                      status {\n                        kind\n                        id\n                      }\n                    }\n                    state {\n                      kind\n                      id\n                    }\n                    topLevelMediaType {\n                      kind\n                      id\n                    }\n                  }\n                  kind\n                  link\n                }\n              }\n            }\n          }\n        }\n      }\n      mediaAbout {\n        count\n        edges {\n          cursor\n          story {\n            __typename\n            ... on OriginalContentStory {\n              __typename\n              id\n              revision\n              landingPageUrl\n              sourceList\n              durationInSeconds\n              description\n              externalId\n              subTitle\n              title\n              label\n              link\n              previews {\n                count\n                edges {\n                  cursor\n                  preview {\n                    mediaAsset {\n                      id\n                      files {\n                        id\n                        name\n                        heightInPixels\n                        widthInPixels\n                        path\n                        status {\n                          kind\n                          id\n                        }\n                      }\n                      state {\n                        kind\n                        id\n                      }\n                      topLevelMediaType {\n                        kind\n                        id\n                      }\n                    }\n                    kind\n                    link\n                  }\n                }\n              }\n            }\n            ... on RadivisionPost {\n              __typename\n              id\n              link\n              previews {\n                count\n                edges {\n                  cursor\n                  preview {\n                    mediaAsset {\n                      id\n                      files {\n                        id\n                        name\n                        heightInPixels\n                        widthInPixels\n                        path\n                        status {\n                          kind\n                          id\n                        }\n                      }\n                      state {\n                        kind\n                        id\n                      }\n                      topLevelMediaType {\n                        kind\n                        id\n                      }\n                    }\n                    kind\n                    link\n                  }\n                }\n              }\n              subTitle\n              title\n              description\n              content\n              landingPageUrl\n              revision\n            }\n            ... on OnlineCourseStory {\n              __typename\n              description\n              id\n              link\n              cost\n              previews {\n                count\n                edges {\n                  cursor\n                  preview {\n                    mediaAsset {\n                      id\n                      files {\n                        id\n                        name\n                        heightInPixels\n                        widthInPixels\n                        path\n                        status {\n                          kind\n                          id\n                        }\n                      }\n                      state {\n                        kind\n                        id\n                      }\n                      topLevelMediaType {\n                        kind\n                        id\n                      }\n                    }\n                    kind\n                    link\n                  }\n                }\n              }\n              subTitle\n              title\n              publishedDate\n              timeRequiredInSeconds\n              publisher\n              revision\n            }\n            ... on ArticleStory {\n              __typename\n              description\n              id\n              link\n              subTitle\n              title\n              publisher\n              publishedDate\n              timeToReadInSeconds\n              revision\n              previews {\n                count\n                edges {\n                  cursor\n                  preview {\n                    mediaAsset {\n                      id\n                      files {\n                        id\n                        name\n                        heightInPixels\n                        widthInPixels\n                        path\n                        status {\n                          kind\n                          id\n                        }\n                      }\n                      state {\n                        kind\n                        id\n                      }\n                      topLevelMediaType {\n                        kind\n                        id\n                      }\n                    }\n                    kind\n                    link\n                  }\n                }\n              }\n            }\n            ... on BookStory {\n              __typename\n              description\n              id\n              link\n              previews {\n                count\n                edges {\n                  cursor\n                  preview {\n                    mediaAsset {\n                      id\n                      files {\n                        id\n                        name\n                        heightInPixels\n                        widthInPixels\n                        path\n                        status {\n                          kind\n                          id\n                        }\n                      }\n                      state {\n                        kind\n                        id\n                      }\n                      topLevelMediaType {\n                        kind\n                        id\n                      }\n                    }\n                    kind\n                    link\n                  }\n                }\n              }\n              subTitle\n              title\n            }\n            ... on NewsletterStory {\n              __typename\n              description\n              link\n              id\n              previews {\n                count\n                edges {\n                  cursor\n                  preview {\n                    mediaAsset {\n                      id\n                      files {\n                        id\n                        name\n                        heightInPixels\n                        widthInPixels\n                        path\n                        status {\n                          kind\n                          id\n                        }\n                      }\n                      state {\n                        kind\n                        id\n                      }\n                      topLevelMediaType {\n                        kind\n                        id\n                      }\n                    }\n                    kind\n                    link\n                  }\n                }\n              }\n              subTitle\n              title\n              publisher\n              publishedDate\n              timeToReadInSeconds\n            }\n            ... on PodcastStory {\n              __typename\n              description\n              durationInSeconds\n              id\n              title\n              subTitle\n              link\n              publisher\n              landingPageUrl\n              previews {\n                count\n                edges {\n                  cursor\n                  preview {\n                    mediaAsset {\n                      id\n                      files {\n                        id\n                        name\n                        heightInPixels\n                        widthInPixels\n                        path\n                        status {\n                          kind\n                          id\n                        }\n                      }\n                      state {\n                        kind\n                        id\n                      }\n                      topLevelMediaType {\n                        kind\n                        id\n                      }\n                    }\n                    kind\n                    link\n                  }\n                }\n              }\n              revision\n            }\n            ... on Node {\n              id\n            }\n          }\n        }\n      }\n      marketplace {\n        count\n        edges {\n          cursor\n          story {\n            __typename\n            ... on MarketEntryStory {\n              __typename\n              id\n              revision\n              state\n              expires\n              landingPageUrl\n              offerType\n              description\n              promoCode\n              subTitle\n              title\n              label\n              link\n              previews {\n                count\n                edges {\n                  cursor\n                  preview {\n                    mediaAsset {\n                      id\n                      files {\n                        id\n                        name\n                        heightInPixels\n                        widthInPixels\n                        path\n                        status {\n                          kind\n                          id\n                        }\n                      }\n                      state {\n                        kind\n                        id\n                      }\n                      topLevelMediaType {\n                        kind\n                        id\n                      }\n                    }\n                    kind\n                    link\n                  }\n                }\n              }\n            }\n            ... on Node {\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '838dcfc7e4731abb27ffaa657f68916f';
export default node;
